import Cookies from 'js-cookie'
import { 
  UserKey, 
  TokenKey, 
  AuthKey, 
  LicenceKey,
  AgentKey,
  TermsKey
} from './keys'
import local from './local'
import { jsonParse } from '../index'
const expires = 1.5
//登录相关
export const SaveLoginData = ({ token, auth, user, agent }) => {
  //存储token
  token &&
  Cookies.set(TokenKey, token, { expires })
  //存储权限代码
  local.setItem(AuthKey, auth ? auth.join(','): '', expires)
  //存储用户信息
  Cookies.set(UserKey, JSON.stringify(user), { expires })
  //存储代理信息
  local.setItem(AgentKey, agent ? JSON.stringify(agent) : '', expires)
}
export const removeLoginData = () => {
  Cookies.remove(TokenKey)
  local.removeItem(AuthKey)
  Cookies.remove(UserKey)
  local.removeItem(AgentKey)
}
export const GetToken = () => Cookies.get(TokenKey) || ''
export const GetAuth = () => local.getItem(AuthKey).split(',')
export const GetUser = () => {
  let userInfo = jsonParse(Cookies.get(UserKey))
  return typeof userInfo == 'object'
    ? userInfo
    : {}
}
export const GetAgent = () => {
  let userInfo = jsonParse(Cookies.get(AgentKey))
  return typeof userInfo == 'object'
    ? userInfo
    : {}
}
//确认协议
export const Licence = {
  get: () => {
    let data = Cookies.get(LicenceKey) || '2'
    return parseInt(data) == 1 ? 1 : 2
  },
  set: (data, expires = 15) => {
    data == 1
    ? Cookies.set(LicenceKey, '1', { expires })
    : Cookies.remove(LicenceKey)
  }
}
//条款
export const Terms = {
  get: () => {
    let data = Cookies.get(TermsKey) || '2'
    return parseInt(data) == 1 ? 1 : 2
  },
  set: (
    data, 
    expires = 15  //默认15天
  ) => {
    data == 1
    ? Cookies.set(TermsKey, '1', { expires })
    : Cookies.remove(TermsKey)
  }
}


// WEBPACK FOOTER //
// ./src/utils/cookies/index.js